// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1rCcz","rootCenter":"LoadMoreObserver_rootCenter__IUTFT","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__sc6Sr"};